import {get, post} from "./utils"
import {ObjectSchema} from "./config";
import moment from "moment";


export interface PlanNode {
    id: string
    is_page_node: boolean
    title: string
    urls: string[]

    page_type_id: number
    children: PlanNode[] | null
    is_recursive: boolean
    crawl_schema: ObjectSchema | null

    schema_slug: string
    is_extract_multiple: boolean
    is_entry: boolean
}

export async function getCrawlPlan(siteID: number): Promise<PlanNode[]> {
    const resp = await get<any>(`/api/site/${siteID}/plan`)
    return resp.roots
}

export enum DebugCrawlStatus {
    Wait = "wait",
    InProgress = "in_progress",
    Finished = "finished",
    Error = "error"
}

export interface SchemaStats {
    valid_count: number
    invalid_count: number
}

export interface DebugCrawlState {
    status: DebugCrawlStatus
    error: string
    items_count_by_schema: Map<string, SchemaStats>
    processed_urls_count: number
    start_time: moment.Moment
}

export async function getCrawlStatus(id: string): Promise<DebugCrawlState> {
    const resp = await get<any>(`/api/crawler/task/${id}/state`)
    return {
        status: resp.state.status,
        error: resp.state.error,
        items_count_by_schema: new Map(Object.entries(resp.state.items_count_by_schema)),
        processed_urls_count: resp.state.processed_urls_count,
        start_time: moment(resp.state.start_time),
    }
}

export async function launchDebugCrawl(site_id: number, max_duration_sec: number, max_publications: number, max_urls: number): Promise<string> {
    const resp = await post<any, any>(`/api/crawler/launch/${site_id}`, {
        max_duration_sec: max_duration_sec,
        max_publications: max_publications,
        max_urls: max_urls,
    })
    return resp.id
}